//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { IModalService } from 'angular-ui-bootstrap';
import { IStateService } from 'angular-ui-router';

// Import the react equivalent
import 'app/components/content/MediaCollectionsSidebar';

import {
  CONTENT_COLLECTION_CONTEXTS,
  ICollection,
  ICollectionState,
} from '@legacy-components/content/content-collections-models';
import template from '@legacy-components/content/content-collections-sidebar.html';

export interface ICollectionSidebarState {
  name: string;
  state: ICollectionState;
}

class ContentCollectionsSidebar {
  public collections: ICollection[];
  public collectionStates: ICollectionSidebarState[];

  public teamMediaState: ICollectionState;
  public myMediaState: ICollectionState;
  public allMediaState: ICollectionState;
  public trackedSourcesState: ICollectionState;

  public constructor(
    private $modal: IModalService,
    private $state: IStateService,
    private CollectionsService,
    private ErrorNotificationService,
  ) {
    this.teamMediaState = {
      view: CONTENT_COLLECTION_CONTEXTS.TEAM_MEDIA,
      params: {},
    };

    this.myMediaState = {
      view: CONTENT_COLLECTION_CONTEXTS.MY_MEDIA,
      params: {},
    };

    this.allMediaState = {
      view: CONTENT_COLLECTION_CONTEXTS.ALL_MEDIA,
      params: {},
    };

    this.trackedSourcesState = {
      view: CONTENT_COLLECTION_CONTEXTS.TRACKED_SOURCES,
      params: {},
    };
  }

  public $onChanges = () => {
    this.collectionStates = this.collections.map((c: ICollection) => {
      return {
        name: c.name,
        state: {
          view: CONTENT_COLLECTION_CONTEXTS.COLLECTIONS,
          params: {
            collectionId: c.id,
          },
        },
      };
    });
  };

  public createCollection = (collectionName: string) => {
    this.CollectionsService.createCollectionWithoutNotification({
      name: collectionName,
    }).subscribe(
      (collection: ICollection) => {
        this.$state.go('library.collections.content', {
          collectionId: collection.id,
        });
      },
      (error) => {
        this.ErrorNotificationService.showDefaultErrorDialog(error);
      },
    );
  };

  public createNewEmptyCollection = () => {
    const modal = this.$modal.open({
      template:
        '<collection-naming-modal ' +
        'modal-instance="modalInstance" ' +
        'click-origin="EmptyFromSidebar" ' +
        '></collection-naming-modal>',
      windowClass: 'pure-bs3 modal-collection-name',
      controller: [
        '$modalInstance',
        '$scope',
        ($modalInstance, $scope) => {
          $scope.modalInstance = $modalInstance;
        },
      ],
    });

    modal.result.then((collectionName) => {
      this.createCollection(collectionName);
    });
  };
}

angular.module('curalate').component('contentCollectionsSidebar', {
  bindings: {
    collections: '<',
  },
  controller: [
    '$modal',
    '$state',
    'CollectionsService',
    'ErrorNotificationService',
    ContentCollectionsSidebar,
  ],
  template,
});
